import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function CustomDialog({
    open,
    title = '',
    children,
    onClose,
    actions,
    maxWidth = 'md',
    fullWidth = true,
}) {
    return (
        <BootstrapDialog
            onClose={onClose}
            aria-labelledby="custom-dialog-title"
            open={open}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="custom-dialog-title">
                {title}
            </DialogTitle>

            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent dividers>{children}</DialogContent>

            {actions && <DialogActions>{actions}</DialogActions>}
        </BootstrapDialog>
    );
}
